import React from 'react';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';

export const DialogDescricaoPlanejamento = ({ visible, setVisible, descricao }) => {
    return (
        <Dialog
            visible={visible}
            onHide={() => setVisible(false)}
            className='p-scrollpanel-bar-y'
            breakpoints={{ '960px': '75vw', '640px': '100vw' }}
            style={{ width: '50vw', heigth: '5vw' }}
        >
            <div>
                <InputTextarea
                    id="descricao"
                    name="descricao"
                    className="descricao"
                    value={descricao}
                    cols={110}
                    rows={35}
                    autoResize
                />
            </div>

        </Dialog>
    );
}